module.exports = __webpack_public_path__ + "img/thank_you_heart.fc4a6164.svg";